import {
  returnTransactionClick,
  transactionBasedReturnClick,
} from '../../return-services-display/business-logic/return-transaction';
import { CustomerServiceUserActions } from '../interfaces/customer-service-user-actions';
import { HandleCustomerServiceActions } from './handle-customer-service-actions';
import { IActionButton } from 'src/common/interfaces/dtos/ICashOfficeActionButton';
import { handleBottleDeposit } from 'src/bottle-deposit/business-logic/handle-bottle-deposit';

export const generateCustomerServiceActionButtons = (): IActionButton[] => {
  return [
    // Remove Return All button for RBS Demo/until Return All is supported (XLR-6119)
    // {
    //   id: 'return-all-action-button',
    //   text: 'ReturnAll_Command',
    //   handleClick: () => {},
    //   isDisabled: false,
    // },
    {
      id: 'return-transaction-action-button',
      text: 'Return_Transaction',
      handleClick: () => returnTransactionClick(),
      isDisabled: isCustomerServiceButtonEnabled('return-transaction-action-button'),
    },
    {
      id: 'transaction-based-return-action-button',
      text: 'TransactionBasedReturnCommand',
      handleClick: () => transactionBasedReturnClick(),
      isDisabled: isCustomerServiceButtonEnabled('return-transaction-action-button'),
    },
    {
      id: 'bottle-return-action-button',
      text: 'BottleReturn_Command',
      handleClick: () => handleBottleDeposit(),
      isDisabled: isCustomerServiceButtonEnabled('bottle-return-action-button'),
    },
  ];
};

export const isCustomerServiceButtonEnabled = (buttonId: string): boolean => {
  const customerServiceUserActions: CustomerServiceUserActions = HandleCustomerServiceActions.customerServiceAccess();

  switch (buttonId) {
    case 'return-all-action-button':
      return customerServiceUserActions.allActions || customerServiceUserActions.returnAll;
    case 'return-transaction-action-button':
      return customerServiceUserActions.allActions || customerServiceUserActions.returnTransaction;
    case 'transaction-based-return-action-button':
      return (
        customerServiceUserActions.allActions || customerServiceUserActions.transactionBasedReturn
      );
    case 'bottle-return-action-button':
      return customerServiceUserActions.allActions || customerServiceUserActions.bottleReturn;
    default:
      return false;
  }
};
